import script from "./PlatformControlView.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformControlView.vue?vue&type=script&setup=true&lang=js"

import "./PlatformControlView.vue?vue&type=style&index=0&id=8175522a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8175522a"]])

export default __exports__